import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-goods",
  "use": "icon-goods-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-goods\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <path d=\"M218.654118 342.979765l-73.667765 540.912941h734.569412l-64.933647-540.912941H218.654118zM212.871529 275.275294h607.834353c30.780235 0 56.741647 23.070118 60.355765 53.609412l66.620235 554.465882a60.837647 60.837647 0 0 1-53.187764 67.584c-3.614118 0.421647-3.614118 0.421647-7.228236 0.481883H137.396706a60.837647 60.837647 0 0 1-60.837647-60.837647c0-4.096 0-4.096 0.421647-8.192l75.535059-554.405648a60.837647 60.837647 0 0 1 60.295529-52.705882z m197.752471 101.436235a33.792 33.792 0 0 1-67.584 0V241.543529a169.020235 169.020235 0 0 1 338.040471 0v135.228236a33.792 33.792 0 0 1-67.584 0V241.543529a101.436235 101.436235 0 0 0-202.872471 0v135.228236z\" p-id=\"4071\" />\r\n  <path d=\"M309.187765 681.020235a33.792 33.792 0 0 1 0-67.584h405.62447a33.792 33.792 0 0 1 0 67.584H309.187765z\" p-id=\"4072\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/goods.svg
// module id = XNJ4
// module chunks = 60